import React, { useState, useEffect } from 'react';
import AddUnidadMedida from './AddUnidadMedida';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionUnidades() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [unidades, setUnidades] = useState([]);
    const [editingUnidad, setEditingUnidad] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [unidadToDelete, setUnidadToDelete] = useState(null);
    const { user } = useUser();

    const fetchUnidades = async () => {
        try {
            const response = await fetch(`${server}/MgUnidadesDeMedidums`);
            const data = await response.json();
            setUnidades(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las unidades: ' + error,
            });
        }
    };

    useEffect(() => {
        fetchUnidades();
    }, []);

    const handleNewUnidad = () => {
        fetchUnidades();
        setEditingUnidad(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleOpenDialog = (unidad) => {
        setUnidadToDelete(unidad);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setUnidadToDelete(null);
    };

    const handleDeleteUnidad = async () => {
        if (unidadToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                const response = await fetch(`${server}/MgUnidadesDeMedidums/${unidadToDelete.idUnidadDeMedida}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchUnidades();
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'País eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar la unidad: ' + error,
                });
            }
        }
    };

    const filteredUnidades = unidades.filter(unidad => unidad.descripcionUnidadDeMedida?.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
        <>
            <div className="x_title">
                
            </div>
            <div className="x_content">
                <br />
                <AddUnidadMedida onNewUnidad={handleNewUnidad} editingUnidad={editingUnidad} />
                <div className="ln_solid" />
                <h2>Unidades de Medida Existentes</h2>
                <div className="row">
                    <div className="col-md-5 col-sm-4 offset-md-3">
                        <TextField
                            variant="outlined"
                            label="Buscar unidad"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredUnidades.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((unidad) => (
                                            <TableRow key={unidad.idUnidadDeMedida}>
                                                <TableCell>{unidad.descripcionUnidadDeMedida}</TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditingUnidad(unidad)} color="primary" disabled={!tienePermiso('Editar Unidad Medida')}>Editar</Button>
                                                    <Button onClick={() => handleOpenDialog(unidad)} color="secondary" disabled={!tienePermiso('Eliminar Unidad Medida')}>Eliminar</Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredUnidades.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar la unidad seleccionada?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteUnidad} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default GestionUnidades;
